const HomeScreenManagement = () => {
  return (
    <div>
      <h1>Hello World</h1>
    </div>
  );
};

export default HomeScreenManagement;
